<template>
  <aha-modal
    size="md"
    @hide="reloadPage"
    title="Welcome back!"
    class="be-taken-over-modal"
  >
    <p class="mb-2">
      You were gone for a while. To continue editing, please refresh.
    </p>
    <template #action>
      <aha-button
        @click="reloadPage"
      >
        Refresh
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>

export default {
  props: {
    presenter: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    reloadPage() {
      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.be-taken-over-modal {
  ::v-deep .aha-modal-content {
    width: 28rem;
  }
}
</style>
